import api from '../common/helpers/apiHelper';
import { IListData } from '../common/models/common/IListData';
import { IPosition } from '../common/models/position/IPosition';
import { IFilter } from '../common/models/filter/IFilter';
import { mapSortToSortReq, mapFilterToFilterReq } from '../common/helpers/filterHelper';
import { PositionCounts } from '../common/models/position/PositionCounts';
import { IPositionFilter } from '../common/models/filter/IPositionFilter';
import { IReferenceReqPosition } from '../common/models/position/IReferenceReqPosition';
import { ILastRefReqCounters } from '../common/models/referenceRequest/ILastRefReqCounters';
import { ICounterFilter } from '../common/models/filter/ICounterFilter';
import { IPositionProfileCounters } from '../common/models/position/IPositionProfileCounters';
import { ISelectedSurvey } from '../common/models/survey/ISelectedSurvey';
import { CandidateCounts } from '../common/models/candidate/CandidateCounts';
import { IUpdatePosition } from '../common/models/position/IUpdatePosition';
import { IPositionName } from '../common/models/position/IPositionName';

export const getPositions = (payload: IFilter) => api.get<IListData<IPosition>>(
  '/api/positions/',
  { ...payload, sort: mapSortToSortReq(payload.sort), filter: mapFilterToFilterReq(payload.filter) }
);

export const getPositionById = (id: string) => api.get<IPositionProfileCounters>(`/api/positions/${id}`);

export const getPositionCountersById = (id: string) => api.get<CandidateCounts>(`/api/positions/${id}/counters`);

export const getPositionCounters = (payload: ICounterFilter) => api.get<PositionCounts>(
  '/api/positions/counters',
  { ...payload, filter: mapFilterToFilterReq(payload.filter) }
);

export const getReqBuilderPositions = (payload: IPositionFilter) => api.get<IListData<IReferenceReqPosition[]>>(
  '/api/positions/ref-request',
  { ...payload }
);

export const getRecentPositions = () => api.get<IReferenceReqPosition[]>('/api/positions/recent');

export const postPosition = (name: string) => api.post<IReferenceReqPosition>(
  '/api/positions',
  { name }
);

export const getLastRefCounters = (positionId: string) => api.get<ILastRefReqCounters>(
  `/api/positions/${positionId}/last-ref-request`
);

export const getLastPositionSurvey = (positionId: string) => api.get<ISelectedSurvey[]>(
  `/api/positions/${positionId}/last-surveys`
);

export const checkPositionName = (payload: IPositionName) => api.get<{ isNameTaken: boolean }>(
  '/api/positions/name',
  payload
);

export const updatePosition = ({ id, name }: IUpdatePosition) => api.put<any>( // fix any
  `/api/positions/${id}`,
  { name }
);

export const mergePositions = (payload: IPositionName) => api.post<void>(
  '/api/positions/merge', payload
);
